/* eslint-disable */
export default {
  noActiveCalls: 'Aucun appel actif',
  noRecords: 'Aucun résultat.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
